<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                <v-icon class="me-2">mdi-filter</v-icon>
                                Search Form
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="pa-2">
                                        <v-col md="3" cols="12">
                                            <v-date-input
                                                label="From Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar-month"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="from_date.value.value"
                                                :error-messages="from_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>
                                        </v-col>
                                        <v-col md="3" cols="12">
                                            <v-date-input
                                                label="To Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar-month"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="to_date.value.value"
                                                :error-messages="to_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>
                                        </v-col>
                                        <v-col lg="2" md="2" cols="12">
                                            <v-btn
                                                class="bg-brand w-15"
                                                type="submit"
                                                ref="searchButton"
                                            >
                                                Search
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid style="margin-top: -20px;">
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                <v-icon class="me-2">mdi-file-check-outline</v-icon>
                                PO Approval Report
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-row class="py-2">
                                    <v-col md="4" cols="6">
                                        <v-text-field
                                            v-model="search"
                                            append-inner-icon="mdi-magnify"
                                            label="Search"
                                            single-line
                                            hide-details
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            class="pl-2"
                                            clearable
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="4" cols="6">
                                        <v-btn-group
                                            variant="outlined"
                                            density="compact"
                                            size="x-small"
                                            divided
                                        >
                                            <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="success"
                                                @click="exportToCSV"
                                                :disabled="getSchema.length === 0"
                                            >CSV</v-btn>
                                            <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="primary"
                                                @click="exportToExcel"
                                                :disabled="getSchema.length === 0"
                                            >EXCEL</v-btn>
                                            <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="red"
                                                @click="exportToPDF"
                                                :disabled="getSchema.length === 0"
                                            >PDF</v-btn>
                                        </v-btn-group>
                                    </v-col>
                                </v-row>

                                <div v-if="!getSchema.length && !loading" class="py-6 text-center text-medium-emphasis">
                                    <v-icon size="64" color="grey-lighten-1" class="mb-2">mdi-file-remove</v-icon>
                                    <div class="text-h6 text-grey mt-4">No Approval Data Found</div>
                                    <div class="text-body-2 text-grey">Try adjusting filters or search criteria</div>
                                </div>

                                <v-data-table
                                    v-else
                                    :headers="headers"
                                    :items="getSchema"
                                    :loading="loading"
                                    v-model:items-per-page="itemsPerPage"
                                    :search="search"
                                    :hover="true"
                                    density="compact"
                                >
                                    <template v-slot:item.index="{ index }">
                                        {{ ++index }}
                                    </template>
                                    <template v-slot:item.referenceable.code="{ item }">
                                        <v-chip size="small" color="primary" variant="outlined">
                                            {{ item.referenceable?.code || 'N/A' }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:item.approved_at="{ item }">
                                        {{ formatDateTime(item.approved_at) }}
                                    </template>
                                    <template v-slot:item.status="{ item }">
                                        <v-chip
                                            :color="getStatusColor(item.status)"
                                            size="small"
                                            variant="flat"
                                        >
                                            {{ item.status || 'Pending' }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:item.employee.name="{ item }">
                                        {{ item.employee?.name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.employee.designation.name="{ item }">
                                        {{ item.employee?.designation?.name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.employee.department.name="{ item }">
                                        {{ item.employee?.department?.name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.approval_step_name.name="{ item }">
                                        {{ item.approval_step_name?.name || item.approvalStepName?.name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.approved_by.role.name="{ item }">
                                        {{ item.approved_by?.role?.name || item.approvedBy?.role?.name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.comments="{ item }">
                                        {{ item.comments || 'N/A' }}
                                    </template>
                                </v-data-table>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { formatDateDash } from "@/plugins/dateFormatView";
import formattedDate from "@/plugins/dateFormatter";

export default {
    data: () => ({
        itemsPerPage: -1,
        panel: [0],
        panel2: [0],
        search: "",
        headers: [
            { title: "#SL", key: "index", align: "center", width: "5%", sortable: false },
            { title: "PO Code", key: "referenceable.code", align: "left", sortable: true, width: "120px" },
            { title: "Employee", key: "employee.name", align: "left", sortable: false, width: "150px" },
            { title: "Department", key: "employee.department.name", align: "left", sortable: false, width: "150px" },
            { title: "Designation", key: "employee.designation.name", align: "left", sortable: false, width: "150px" },
            { title: "Approve Qty", key: "referenceable.req_sum_qty", align: "right", sortable: false, width: "110px" },
            { title: "Approval Step", key: "approval_step_name.name", align: "left", sortable: false, width: "150px" },
            { title: "Approved By Role", key: "approved_by.role.name", align: "left", sortable: false, width: "160px" },
            { title: "Approval Status", key: "status", align: "center", sortable: true, width: "140px" },
            { title: "Approved At", key: "approved_at", align: "left", sortable: true, width: "180px" },
            { title: "Remarks", key: "comments", align: "left", sortable: false, width: "220px" },
        ],
    }),
    computed: {
        getSchema() {
            return this.$store.getters.getPurPOApprovalReport;
        },
    },
    setup() {
        const { handleSubmit } = useForm({
            validationSchema: yup.object({}),
        });

        const from_date = useField("from_date");
        const to_date = useField("to_date");
        const loading = ref(false);
        const store = useStore();

        const submit = handleSubmit(() => {
            loading.value = true;
            const params = {};
            if (from_date.value.value) {
                params.from_date = formattedDate(from_date.value.value);
            }
            if (to_date.value.value) {
                params.to_date = formattedDate(to_date.value.value);
            }
            store
                .dispatch("getPurPOApprovalReport", params)
                .then((response) => {
                    loading.value = false;
                    if (response.data.success) {
                        toast.success(response.data.message || "Data loaded successfully");
                    }
                })
                .catch((error) => {
                    loading.value = false;
                    toast.error(error?.response?.data?.message || "An error occurred");
                });
        });

        return {
            from_date,
            to_date,
            submit,
            loading,
        };
    },
    methods: {
        formatDateDash,
        formattedDate,
        formatDateTime(date) {
            if (!date) return "N/A";
            return new Date(date).toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        },
        getStatusColor(status) {
            if (!status) return "grey";
            const statusLower = status.toLowerCase();
            if (statusLower.includes("approved")) return "success";
            if (statusLower.includes("reject")) return "error";
            if (statusLower.includes("pending")) return "warning";
            if (statusLower.includes("hold")) return "info";
            return "grey";
        },
        exportToCSV() {
            if (!this.getSchema || this.getSchema.length === 0) {
                toast.warning("No data to export");
                return;
            }

            const columns = [
                "#SL",
                "PO Code",
                "Employee",
                "Department",
                "Designation",
                "Approve Qty",
                "Approval Step",
                "Approved By Role",
                "Approval Status",
                "Approved At",
                "Remarks",
            ];

            let serialNum = 1;
            const rows = this.getSchema.map((item) => [
                serialNum++,
                item.referenceable?.code ?? "",
                item.employee?.name ?? "",
                item.employee?.department?.name ?? "",
                item.employee?.designation?.name ?? "",
                item.referenceable?.req_sum_qty ?? 0,
                item.approval_step_name?.name || item.approvalStepName?.name || "",
                item.approved_by?.role?.name || item.approvedBy?.role?.name || "",
                item.status ?? "",
                this.formatDateTime(item.approved_at),
                item.comments ?? "",
            ]);

            const data = [columns, ...rows];
            const proxy = this.$appContext?.config?.globalProperties;
            if (proxy?.$exportTableToCSV && proxy?.$fileDate) {
                proxy.$exportTableToCSV(data, "po_approval_report_" + proxy.$fileDate());
            } else if (this.$exportTableToCSV && this.$fileDate) {
                this.$exportTableToCSV(data, "po_approval_report_" + this.$fileDate());
            }
        },
        exportToExcel() {
            if (!this.getSchema || this.getSchema.length === 0) {
                toast.warning("No data to export");
                return;
            }

            const data = [[
                "#SL",
                "PO Code",
                "Employee",
                "Department",
                "Designation",
                "Approve Qty",
                "Approval Step",
                "Approved By Role",
                "Approval Status",
                "Approved At",
                "Remarks",
            ]];

            let serialNum = 1;
            this.getSchema.forEach((item) => {
                data.push([
                    serialNum++,
                    item.referenceable?.code ?? "",
                    item.employee?.name ?? "",
                    item.employee?.department?.name ?? "",
                    item.employee?.designation?.name ?? "",
                    item.referenceable?.req_sum_qty ?? 0,
                    item.approval_step_name?.name || item.approvalStepName?.name || "",
                    item.approved_by?.role?.name || item.approvedBy?.role?.name || "",
                    item.status ?? "",
                    this.formatDateTime(item.approved_at),
                    item.comments ?? "",
                ]);
            });

            const proxy = this.$appContext?.config?.globalProperties;
            if (proxy?.$exportTableToExcel && proxy?.$fileDate) {
                proxy.$exportTableToExcel(data, "po_approval_report_" + proxy.$fileDate());
            } else if (this.$exportTableToExcel && this.$fileDate) {
                this.$exportTableToExcel(data, "po_approval_report_" + this.$fileDate());
            }
        },
        exportToPDF() {
            if (!this.getSchema || this.getSchema.length === 0) {
                toast.warning("No data to export");
                return;
            }

            const columns = [
                "#SL",
                "PO Code",
                "Employee",
                "Department",
                "Designation",
                "Approve Qty",
                "Approval Step",
                "Approved By Role",
                "Approval Status",
                "Approved At",
                "Remarks",
            ];

            let serialNum = 1;
            const rows = this.getSchema.map((item) => [
                serialNum++,
                item.referenceable?.code ?? "",
                item.employee?.name ?? "",
                item.employee?.department?.name ?? "",
                item.employee?.designation?.name ?? "",
                item.referenceable?.req_sum_qty ?? 0,
                item.approval_step_name?.name || item.approvalStepName?.name || "",
                item.approved_by?.role?.name || item.approvedBy?.role?.name || "",
                item.status ?? "",
                this.formatDateTime(item.approved_at),
                item.comments ?? "",
            ]);

            const proxy = this.$appContext?.config?.globalProperties;
            if (proxy?.$exportTableToPDF && proxy?.$fileDate) {
                proxy.$exportTableToPDF(columns, rows, "PO Approval Report", "po_approval_report_" + proxy.$fileDate());
            } else if (this.$exportTableToPDF && this.$fileDate) {
                this.$exportTableToPDF(columns, rows, "PO Approval Report", "po_approval_report_" + this.$fileDate());
            }
        },
    },
};
</script>

<style scoped>
.panel-header {
    font-weight: 600;
}
</style>

